import axios from 'axios';
import url from '../config';
import moment from 'moment';
import swal from '@sweetalert/with-react'
import { WHATSAPP_FETCH_AUDIENCELIST, WHATSAPP_FETCH_BULK_MESSGAE_LSIT } from './actiontypes';

export function addAudienceWhatsapp(audienceData) {
    return async (dispatch) => {
        try {
            console.log("Audience data", audienceData);
            let { audienceName, file, phoneType } = audienceData;
            let formData = new FormData();
            formData.append("audienceName", audienceName);
            formData.append("file", file);
            formData.append("phoneType", phoneType);
            let response = await axios.post(`${url.pathBackend}whatsapp/bulkmessage/addAudience`, formData);
            response = response.data;
            if (response.error) {
                alert(response.error || "Some Error Ocurred");
                return;
            }
            alert("Success");
            return;
        }
        catch (e) {
            console.log(e);
        }
    }
}

export function fetchAudienceList() {
    return async (dispatch) => {
        try {
            let response = await axios.post(`${url.pathBackend}whatsapp/bulkmessage/fetchAudience`);
            response = response.data;
            if (response.error) {
                alert(response.error || "Some Error Ocurred");
                return;
            }
            dispatch({ type: WHATSAPP_FETCH_AUDIENCELIST, payload: response.data || [] });
            return;
        }
        catch (e) {
            console.log(e);
        }
    }
}

export function sendMessageWhatsapp(messageData) {
    return async (dispatch) => {
        try {
            console.log("messageData", messageData);
            let formData = new FormData();
            Object.keys(messageData).forEach(field => {
                formData.append(field, messageData[field]);
            })
            let response = await axios.post(`${url.pathBackend}whatsapp/bulkmessage/sendMessage`, formData);
            response = response.data;
            if (response.error) {
                alert(response.error || "Some Error Ocurred");
                return;
            };
            alert("Message scheduled");
            return;
        }
        catch (e) {
            console.log(e);
        }
    }
}

export function fetchBulkMessageList() {
    return async (dispatch) => {
        try {
            let response = await axios.post(`${url.pathBackend}whatsapp/bulkmessage/fetchMessages`);
            response = response.data;
            if (response.error) {
                alert(response.error || "Some Error Ocurred");
                return;
            };
            dispatch({ type: WHATSAPP_FETCH_BULK_MESSGAE_LSIT, payload: response.data || [] });
            return;
        }
        catch (e) {
            console.log(e);
        }
    }
}

export function approveMessage(id) {
    return async (dispatch) => {
        try {
            let response = await axios.post(`${url.pathBackend}whatsapp/bulkmessage/approveMessage`, { messageId: id });
            response = response.data;
            if (response.error) {
                alert(response.error || "Some Error Ocurred");
                return;
            };
            return;
        }
        catch (e) {
            console.log(e);
        }
    }
}

export function testSendMessage(messageData) {
    return async (dispatch) => {
        try {
            console.log("messageData", messageData);
            let formData = new FormData();
            Object.keys(messageData).forEach(field => {
                formData.append(field, messageData[field]);
            })
            let response = await axios.post(`${url.pathBackend}whatsapp/bulkmessage/testSendMessage`, formData);
            response = response.data;
            if (response.error) {
                alert(response.error || "Some Error Ocurred");
                return;
            };
            alert("Test message sent");
            return;
        }
        catch (e) {
            console.log(e);
        }
    }
}

export function downloadAudFormat(type) {
    return async (dispatch) => {
        try {
            let response = await axios.post(`${url.pathBackend}whatsapp/bulkmessage/downloadAudFormat`, { type: type });
            response = response.data;
            if(response.error){
                alert("Some Error Ocurred");
                return;
            }
            let fileData = response || {};
            let { Body = {}, ContentType, fileName = 'Format.csv' } = fileData;
            const blob = new Blob([new Uint8Array(Body.data)], { type: ContentType });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        }
        catch (e) {
            console.log(e);
        }
    }
}

export function downloadAudFile(filePath) {
    return async (dispatch) => {
        try {
            let response = await axios.post(`${url.pathBackend}whatsapp/bulkmessage/downloadAudFile`, { filePath: filePath });
            response = response.data;
            if(response.error){
                alert("Some Error Ocurred");
                return;
            }
            let fileData = response || {};
            let { Body = {}, ContentType, fileName = 'Audience.csv' } = fileData;
            const blob = new Blob([new Uint8Array(Body.data)], { type: ContentType });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        }
        catch (e) {
            console.log(e);
        }
    }
}

export function downloadAttachmentFile(filePath) {
    return async (dispatch) => {
        try {
            let response = await axios.post(`${url.pathBackend}whatsapp/bulkmessage/downloadAttachmentFile`, { filePath: filePath });
            response = response.data;
            if(response.error){
                alert("Some Error Ocurred");
                return;
            }
            let fileData = response || {};
            let { Body = {}, ContentType, fileName = 'messageFile' } = fileData;
            const blob = new Blob([new Uint8Array(Body.data)], { type: ContentType });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        }
        catch (e) {
            console.log(e);
        }
    }
}

export function cancelMessage(id) {
    return async (dispatch) => {
        try {
            let response = await axios.post(`${url.pathBackend}whatsapp/bulkmessage/cancelMessage`, { messageId: id });
            response = response.data;
            if (response.error) {
                alert(response.error || "Some Error Ocurred");
                return;
            };
            return;
        }
        catch (e) {
            console.log(e);
        }
    }
}